var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  viewBox: "0 0 512 512",
  xmlSpace: "preserve"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 64c105.875 0 192 86.125 192 192s-86.125 192-192 192c-105.859 0-192-86.125-192-192S150.141 64 256 64m0-64C114.625 0 0 114.625 0 256c0 141.391 114.625 256 256 256s256-114.609 256-256C512 114.625 397.375 0 256 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264.375 170.594h-54.5c-8.703 0-15.75 7.031-15.75 15.719V347c0 8.688 7.047 15.719 15.75 15.719h7.906c8.688 0 15.734-7.031 15.734-15.719v-45.25h30.859c41.266 0 74.844-29.406 74.844-65.594.001-36.156-33.577-65.562-74.843-65.562zm0 96.625h-30.859v-62.125h30.859c19.547 0 35.438 13.938 35.438 31.063s-15.891 31.062-35.438 31.062z"
}))));

export default SvgPoint;